// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://optimistic.etherscan.io/address/0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb
export const POOL_ADDRESSES_PROVIDER = '0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb';

// IPool https://optimistic.etherscan.io/address/0x794a61358D6845594F94dc1DB02A252b5b4814aD
export const POOL = '0x794a61358D6845594F94dc1DB02A252b5b4814aD';

// IPoolConfigurator https://optimistic.etherscan.io/address/0x8145eddDf43f50276641b55bd3AD95944510021E
export const POOL_CONFIGURATOR = '0x8145eddDf43f50276641b55bd3AD95944510021E';

// IAaveOracle https://optimistic.etherscan.io/address/0xD81eb3728a631871a7eBBaD631b5f424909f0c77
export const ORACLE = '0xD81eb3728a631871a7eBBaD631b5f424909f0c77';

// https://optimistic.etherscan.io/address/0xE229d5DE4BD5beEAf12d427B5B57BFe66abD2c3b
export const PRICE_ORACLE_SENTINEL = '0xE229d5DE4BD5beEAf12d427B5B57BFe66abD2c3b';

// https://optimistic.etherscan.io/address/0x746c675dAB49Bcd5BB9Dc85161f2d7Eb435009bf
export const ACL_ADMIN = '0x746c675dAB49Bcd5BB9Dc85161f2d7Eb435009bf';

// IACLManager https://optimistic.etherscan.io/address/0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B
export const ACL_MANAGER = '0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B';

// IPoolDataProvider https://optimistic.etherscan.io/address/0x243Aa95cAC2a25651eda86e80bEe66114413c43b
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x243Aa95cAC2a25651eda86e80bEe66114413c43b';

// https://optimistic.etherscan.io/address/0x9b8e56D890BfFBbd385FE8b0E73803A82FCef2F1
export const POOL_IMPL = '0x9b8e56D890BfFBbd385FE8b0E73803A82FCef2F1';

// https://optimistic.etherscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://optimistic.etherscan.io/address/0x929EC64c34a17401F460460D4B9390518E5B473e
export const DEFAULT_INCENTIVES_CONTROLLER = '0x929EC64c34a17401F460460D4B9390518E5B473e';

// https://optimistic.etherscan.io/address/0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73
export const EMISSION_MANAGER = '0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73';

// ICollector https://optimistic.etherscan.io/address/0xB2289E329D2F85F1eD31Adbb30eA345278F21bcf
export const COLLECTOR = '0xB2289E329D2F85F1eD31Adbb30eA345278F21bcf';

// https://optimistic.etherscan.io/address/0x7c03FA1A1d195Db5690E188bd6bBFA87816995eE
export const DEFAULT_A_TOKEN_IMPL = '0x7c03FA1A1d195Db5690E188bd6bBFA87816995eE';

// https://optimistic.etherscan.io/address/0xC0442C25FE517ac37D6a0D485446307D97d24712
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xC0442C25FE517ac37D6a0D485446307D97d24712';

// https://optimistic.etherscan.io/address/0xa59262276dB8F997948fdc4a10cBc1448A375636
export const RISK_STEWARD = '0xa59262276dB8F997948fdc4a10cBc1448A375636';

// https://optimistic.etherscan.io/address/0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034
export const DEBT_SWAP_ADAPTER = '0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034';

// https://optimistic.etherscan.io/address/0x9abADECD08572e0eA5aF4d47A9C7984a5AA503dC
export const L2_ENCODER = '0x9abADECD08572e0eA5aF4d47A9C7984a5AA503dC';

// https://optimistic.etherscan.io/address/0x6F25a890F41c0cDa16AA010b100a64485E1555FF
export const CONFIG_ENGINE = '0x6F25a890F41c0cDa16AA010b100a64485E1555FF';

// https://optimistic.etherscan.io/address/0x770ef9f4fe897e59daCc474EF11238303F9552b6
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x770ef9f4fe897e59daCc474EF11238303F9552b6';

// https://optimistic.etherscan.io/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

// https://optimistic.etherscan.io/address/0x22D76094730fA377184100EFB8CEfC673B89B372
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x22D76094730fA377184100EFB8CEfC673B89B372';

// https://optimistic.etherscan.io/address/0x830C5A67a0C95D69dA5fb7801Ac1773c6fB53857
export const SWAP_COLLATERAL_ADAPTER = '0x830C5A67a0C95D69dA5fb7801Ac1773c6fB53857';

// https://optimistic.etherscan.io/address/0x5c5228aC8BC1528482514aF3e27E692495148717
export const UI_INCENTIVE_DATA_PROVIDER = '0x5c5228aC8BC1528482514aF3e27E692495148717';

// https://optimistic.etherscan.io/address/0xa6741111f4CcB5162Ec6A825465354Ed8c6F7095
export const UI_POOL_DATA_PROVIDER = '0xa6741111f4CcB5162Ec6A825465354Ed8c6F7095';

// https://optimistic.etherscan.io/address/0xBc790382B3686abffE4be14A030A96aC6154023a
export const WALLET_BALANCE_PROVIDER = '0xBc790382B3686abffE4be14A030A96aC6154023a';

// https://optimistic.etherscan.io/address/0x5f2508cAE9923b02316254026CD43d7902866725
export const WETH_GATEWAY = '0x5f2508cAE9923b02316254026CD43d7902866725';

// https://optimistic.etherscan.io/address/0x78F8Bd884C3D738B74B420540659c82f392820e0
export const WITHDRAW_SWAP_ADAPTER = '0x78F8Bd884C3D738B74B420540659c82f392820e0';

// https://optimistic.etherscan.io/address/0x170d6D6FCAbF0Ba3932a03d5f470c16c39c18e39
export const STATA_FACTORY = '0x170d6D6FCAbF0Ba3932a03d5f470c16c39c18e39';

// https://optimistic.etherscan.io/address/0x9601de16a38B6d2Dd5d5f313EEDb4fcAf9718D6C
export const DUST_BIN = '0x9601de16a38B6d2Dd5d5f313EEDb4fcAf9718D6C';

// https://optimistic.etherscan.io/address/0xD835fb6f9823b4054Ccf30403De76AA8abcd00b8
export const CLINIC_STEWARD = '0xD835fb6f9823b4054Ccf30403De76AA8abcd00b8';

// https://optimistic.etherscan.io/address/0x4684b645386525057526EB85854045914Fe389d6
export const POOL_EXPOSURE_STEWARD = '0x4684b645386525057526EB85854045914Fe389d6';

// https://optimistic.etherscan.io/address/0x9f6aA2aB14bFF53e4b79A81ce1554F1DFdbb6608
export const EDGE_RISK_ORACLE = '0x9f6aA2aB14bFF53e4b79A81ce1554F1DFdbb6608';

// https://optimistic.etherscan.io/address/0x14a6801DBEBbd6CBE009c10eCFDA98C1c7B89012
export const EDGE_RISK_STEWARD_CAPS = '0x14a6801DBEBbd6CBE009c10eCFDA98C1c7B89012';

// https://optimistic.etherscan.io/address/0x54714FAc85b0bf627288CC3a186dE81A42f1D635
export const EDGE_INJECTOR_CAPS = '0x54714FAc85b0bf627288CC3a186dE81A42f1D635';

export const CHAIN_ID = 10;
export const ASSETS = {
  DAI: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    A_TOKEN: '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
    V_TOKEN: '0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0xf116891adaBb21Df94663c8Aa62f87fC1bc19d53',
    STATIC_A_TOKEN: '0x6dDc64289bE8a71A707fB057d5d07Cc756055d6e',
    STATA_TOKEN: '0x61b620FAd391b53A2D0973b10a3Ed69558d5c66E',
  },
  LINK: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6',
    A_TOKEN: '0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530',
    V_TOKEN: '0x953A573793604aF8d41F306FEb8274190dB4aE0e',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0xCc232dcFAAE6354cE191Bd574108c1aD03f86450',
    STATIC_A_TOKEN: '0x39BCf217ACc4Bf2fCaF7BC8800E69D986912c75e',
    STATA_TOKEN: '0xC438643b0eee8a314eEC53eb8A1Ee6467C88fc24',
  },
  USDC: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
    A_TOKEN: '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
    V_TOKEN: '0xFCCf3cAbbe80101232d343252614b6A3eE81C989',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x6379A975Ef93EC2bE87f56A02CCF8535dFAde201',
    STATIC_A_TOKEN: '0x9F281eb58fd98ad98EDe0fc4C553AD4D73e7Ca2C',
    STATA_TOKEN: '0x0B590eF479c8e03825Ae779839aCb4583aCc15FD',
  },
  WBTC: {
    decimals: 8,
    id: 3,
    UNDERLYING: '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
    A_TOKEN: '0x078f358208685046a11C85e8ad32895DED33A249',
    V_TOKEN: '0x92b42c66840C7AD907b4BF74879FF3eF7c529473',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0xD702DD976Fb76Fffc2D3963D037dfDae5b04E593',
    STATIC_A_TOKEN: '0x6d998FeEFC7B3664eaD09CAf02b5a0fc2E365F18',
    STATA_TOKEN: '0xEA9020a9e04C557478daD749A1aaD242b443042C',
  },
  WETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    A_TOKEN: '0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8',
    V_TOKEN: '0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x13e3Ee699D1909E989722E753853AE30b17e08c5',
    STATIC_A_TOKEN: '0x98d69620C31869fD4822ceb6ADAB31180475FD37',
    STATA_TOKEN: '0x464b808c2C7E04b07e860fDF7a91870620246148',
  },
  USDT: {
    decimals: 6,
    id: 5,
    UNDERLYING: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
    A_TOKEN: '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
    V_TOKEN: '0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0xDb4E371F8dc7D834D3F1359295c669352ECe7D9c',
    STATIC_A_TOKEN: '0x035c93db04E5aAea54E6cd0261C492a3e0638b37',
    STATA_TOKEN: '0x927CfF131fD5B43FC992D071929b2c095d6E4b70',
  },
  AAVE: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0x76FB31fb4af56892A25e32cFC43De717950c9278',
    A_TOKEN: '0xf329e36C7bF6E5E86ce2150875a84Ce77f477375',
    V_TOKEN: '0xE80761Ea617F66F96274eA5e8c37f03960ecC679',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x338ed6787f463394D24813b297401B9F05a8C9d1',
    STATIC_A_TOKEN: '0xae0Ca1B1Bc6cac26981B5e2b9c40f8Ce8A9082eE',
    STATA_TOKEN: '0x527604E4D87A7562ec653dbe2878D0DCAB7f1972',
  },
  sUSD: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9',
    A_TOKEN: '0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97',
    V_TOKEN: '0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x8ea108096AdEA6Ac059cbEaE6862ce9BB52B4E87',
    STATIC_A_TOKEN: '0x3A956E2Fcc7e71Ea14b0257d40BEbdB287d19652',
    STATA_TOKEN: '0x0ec63A55a688E5Ba26afe8d9250114505E8b60a0',
  },
  OP: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x4200000000000000000000000000000000000042',
    A_TOKEN: '0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf',
    V_TOKEN: '0x77CA01483f379E58174739308945f044e1a764dc',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x0D276FC14719f9292D5C1eA2198673d1f4269246',
    STATIC_A_TOKEN: '0xd4F1Cf9A038269FE8F03745C2875591Ad6438ab1',
    STATA_TOKEN: '0x712Ef4D78f43ecAfa106ea003704a908C99D7f11',
  },
  wstETH: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb',
    A_TOKEN: '0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA',
    V_TOKEN: '0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x724E47194d97263ccb71FDad84b4fed18a8be387',
    STATIC_A_TOKEN: '0xb972abef80046A57409e37a7DF5dEf2638917516',
    STATA_TOKEN: '0xbaF95bB30CDab3d5b7a11B67EDeF5631bD62be86',
  },
  LUSD: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0xc40F949F8a4e094D1b49a23ea9241D289B7b2819',
    A_TOKEN: '0x8Eb270e296023E9D92081fdF967dDd7878724424',
    V_TOKEN: '0xCE186F6Cccb0c955445bb9d10C59caE488Fea559',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x5a602E33B935415477550c709a79cDF23E1355d5',
    STATIC_A_TOKEN: '0x84648dc3Cefb601bc28a49A07a1A8Bad04D30Ad3',
    STATA_TOKEN: '0x413093E03d6aeE4F2F7e48D4b88881bf4932b249',
  },
  MAI: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0xdFA46478F9e5EA86d57387849598dbFB2e964b02',
    A_TOKEN: '0x8ffDf2DE812095b1D19CB146E4c004587C0A0692',
    V_TOKEN: '0xA8669021776Bc142DfcA87c21b4A52595bCbB40a',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x1D85F6eB05f618154ac520D2fDa74C40D21BD93e',
    STATIC_A_TOKEN: '0x60495bC8D8Baf7E866888ecC00491e37B47dfF24',
  },
  rETH: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0x9Bcef72be871e61ED4fBbc7630889beE758eb81D',
    A_TOKEN: '0x724dc807b04555b71ed48a6896b6F41593b8C637',
    V_TOKEN: '0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0xF17e75D58D4Be71B8e674fA104B71a827e38F087',
    STATIC_A_TOKEN: '0xf9ce3c97b4b54F3D16861420f4816D9f68190B7B',
    STATA_TOKEN: '0x8e6a81b9d541A0CeA090818B62C4B2DE7f2A2Cf7',
  },
  USDCn: {
    decimals: 6,
    id: 13,
    UNDERLYING: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    A_TOKEN: '0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5',
    V_TOKEN: '0x5D557B07776D12967914379C71a1310e917C7555',
    INTEREST_RATE_STRATEGY: '0x9359282735496463131139875849d5302Fb4bed1',
    ORACLE: '0x6379A975Ef93EC2bE87f56A02CCF8535dFAde201',
    STATIC_A_TOKEN: '0x4DD03dfD36548C840B563745e3FBeC320F37BA7e',
    STATA_TOKEN: '0x41B334E9F2C0ED1f30fD7c351874a6071C53a78E',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'DAI,USDC,USDT,sUSD,USDCn / ',
    collateralBitmap: '8357',
    collateralAssets: [
      '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
      '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
      '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9',
      '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    ],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '129',
    ltvzeroAssets: [
      '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9',
    ],
    ltv: 1,
    liquidationThreshold: 8700,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'WETH,wstETH,rETH / WETH',
    collateralBitmap: '4624',
    collateralAssets: [
      '0x4200000000000000000000000000000000000006',
      '0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb',
      '0x9Bcef72be871e61ED4fBbc7630889beE758eb81D',
    ],
    borrowableBitmap: '16',
    borrowableAssets: ['0x4200000000000000000000000000000000000006'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
